angular.module('IndicatorTree').directive('categoryTree', function () {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/IndicatorTree/CategoryTree.html',
    controller: 'IndicatorTreeController',
    scope: {
      data: '=',
      selectedItem: '='
    },
    link: function (scope) {

    }
  };
});
